import useWindowSize from 'util/useWindowSize'

const addWindowSize = props => ({
  ...props,
  ...useWindowSize(),
})

export default addWindowSize
